import { makeStyles } from 'tss-react/mui'
import { primary } from '../../../assets/colors'

export const useStyles = makeStyles()((theme) => ({
    anchor: {
        position: 'fixed',
        visibility: 'hidden',
        pointerEvents: 'none'
    },
    // Step copy is authored HTML; `normalizeTourHtml` turns its inline styles into these classes.
    tooltipContent: {
        padding: theme.spacing(1.75, 2, 1.5),
        color: theme.palette.text.primary,
        '& h1, & h2, & h3, & h4, & .tour-title': {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 1.35,
            margin: '0 0 6px',
            color: theme.palette.text.primary
        },
        '& p, & div, & li': {
            fontSize: 13,
            lineHeight: 1.55,
            margin: '0 0 6px',
            color: theme.palette.text.primary
        },
        '& ul, & ol': {
            margin: '0 0 6px',
            paddingLeft: 18
        },
        '& ul': { listStyleType: 'disc' },
        '& ol': { listStyleType: 'decimal' },
        '& strong': {
            fontWeight: 500
        },
        '& .tour-accent, & .tour-accent strong': {
            color: primary
        },
        '& > :last-child': {
            marginBottom: 0
        }
    },
    tooltipBottomBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
        padding: theme.spacing(1, 1.25, 1.25, 1.25),
        borderTop: `1px solid ${theme.palette.divider}`
    },
    stepCounter: {
        fontSize: 12,
        color: theme.palette.text.tertiary,
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap'
    },
    actionButtonsContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.75)
    },
    skipButton: {
        color: theme.palette.text.secondary,
        minWidth: 0,
        height: 28,
        padding: theme.spacing(0, 0.75),
        fontSize: 13
    },
    actionButton: {
        height: 28,
        minWidth: 0,
        padding: theme.spacing(0, 1.5),
        fontSize: 13
    }
}))
